import { Crate, RadioGroup } from '@arcadiapower/shrike';
import styled from 'styled-components';
import { StyledTwoColumnGrid } from '~/components/layout/two-column-grid.style';

export const AddProofDocRowChild = styled.div.attrs({
  direction: 'column',
  style: { paddingTop: '24px', paddingLeft: '24px', paddingRight: '24px' },
  alignItems: 'left',
})``;

export const StyledCrate = styled(Crate)`
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: 8px;
  border: 1px solid ${props => props.theme.colors.background.tertiary};
  padding: 24px;
  margin-bottom: 16px;
  display: flex;
  align-items: start;
  flex-direction: column;

  @media ${props => props.theme.media.tabletLandscapeDown} {
    max-width: 784px;
  }

  @media ${props => props.theme.media.desktopUp} {
    width: 784px;
  }
`;

export const StyledDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ColumnGrid = styled(StyledTwoColumnGrid)`
  padding: 0px;
`;

export const StyledRadioGroup = styled(RadioGroup)`
  legend {
    p {
      font-family: DM Sans Bold, sans-serif;
    }
  }
  label {
    p {
      font-family: DM Sans Regular, sans-serif;
    }
  }
`;
